import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-timesheet-explorer" }

import TimesheetExplorer from "@/views/admin/TimesheetExplorer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectTimesheetExplorer',
  props: {
    id: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TimesheetExplorer, { "project-id": __props.id }, null, 8, ["project-id"])
  ]))
}
}

})